import FullContainerLoader from "@/components/common/loaders/fullContainerLoader";
import PageContainer from "../pageContainer/pageContainer";

export default function PageCircularLoader() {
  return (
    <PageContainer>
      <FullContainerLoader sx={{ minHeight: "100%" }} />
    </PageContainer>
  );
}
